/*
  <swiper-carousel data-swiper='{ ...Swiper options... }'>

  The cart page's "You may also like" row was authored against this custom
  element (see sections/main-cart-items.liquid), but nothing in the theme ever
  defined it — so the carousel never initialised: only the first slide was
  visible inside the `overflow: hidden` track and the prev/next controls did
  nothing for anyone. Defining it here restores the intended behaviour and,
  with Swiper's a11y module, gives the slides and controls real semantics.

  Per CLAUDE.md > "Carousels & Horizontal Scrollers", every instance gets the
  touch / mouse-drag / wheel settings below so trackpad and mouse users can
  navigate too. Merge order: defaults < data-swiper attribute.

  Arrows: `navigation.prevEl` / `nextEl` in the config name them, but they go
  to swiper-arrows.js (window.JiYuSwiperArrows) instead of Swiper's navigation
  module, which sets `disabled` on a <button> arrow at either end and drops
  keyboard focus to <body> (TASKS #157, #161). That file explains why.
*/
(function () {
  if (window.customElements && customElements.get('swiper-carousel')) return;

  var DEFAULTS = {
    grabCursor: true,
    simulateTouch: true,
    allowTouchMove: true,
    touchRatio: 1,
    threshold: 5,
    mousewheel: {
      forceToAxis: true,
      releaseOnEdges: true,
      sensitivity: 1,
      thresholdDelta: 10
    },
    a11y: { enabled: true }
  };

  function merge(target, source) {
    Object.keys(source).forEach(function (key) {
      var value = source[key];
      if (value && typeof value === 'object' && !Array.isArray(value)) {
        target[key] = merge(target[key] && typeof target[key] === 'object' ? target[key] : {}, value);
      } else {
        target[key] = value;
      }
    });
    return target;
  }

  class SwiperCarousel extends HTMLElement {
    connectedCallback() {
      if (this.swiperInstance) return;
      this.init();
    }

    // Destroying the Swiper also takes the arrows' wiring off (swiper-arrows.js).
    disconnectedCallback() {
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
    }

    init() {
      var container = this.querySelector('.swiper');
      if (!container) return;

      // component-swiper.js is deferred and precedes this file in document
      // order, so Swiper is normally ready. Poll as a safety net for the
      // customizer, where a section can be injected before it has run.
      if (typeof Swiper === 'undefined') {
        if ((this._swiperWaits = (this._swiperWaits || 0) + 1) > 50) return;
        setTimeout(this.init.bind(this), 100);
        return;
      }

      var options = merge({}, DEFAULTS);
      var raw = this.dataset.swiper;
      if (raw) {
        try {
          merge(options, JSON.parse(raw));
        } catch (error) {
          console.warn('[swiper-carousel] invalid data-swiper JSON', error);
        }
      }

      // Swiper never sees the arrows; see the header comment.
      var navigation = options.navigation;
      delete options.navigation;

      // Native image drag fights the pointer-driven slide drag.
      this.querySelectorAll('.swiper-slide img').forEach(function (image) {
        image.setAttribute('draggable', 'false');
      });

      this.swiperInstance = new Swiper(container, options);
      // The cart's arrows sit in the heading row, outside this element, so the
      // lookup starts here and then falls back to the whole document.
      if (navigation && navigation.enabled !== false && window.JiYuSwiperArrows) {
        window.JiYuSwiperArrows.wire(this.swiperInstance, {
          prevEl: navigation.prevEl,
          nextEl: navigation.nextEl,
          lockClass: navigation.lockClass,
          root: this
        });
      }
    }
  }

  customElements.define('swiper-carousel', SwiperCarousel);
})();
